export default __webpack_public_path__ + "static/media/template-site-sm.92ab8ba6.jpg";